<template>
  <div>
    <button
      class="btn btn-primary btn-sm"
      data-toggle="tooltip"
      data-placement="top"
      title="New"
      @click="fnShowModal()"
    >
      New
    </button>

    <b-modal ref="modal" size="sm" hide-footer title="Designation - New">
      <div class="d-block">
        <form v-on:submit.prevent="createNew">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=""
                  v-model="name"
                />
                <label class="floatingLabel" for="designation"
                  >Designation</label
                >
                <div class="invalid-feedback" v-if="errors.name">
                  {{ errors.name[0] }}
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-sm">
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Save
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import * as messageService from '../../services/message.service'
import * as designationService from '../../services/designation.service'
export default {
  name: 'ModalDesignationNew',
  data() {
    return {
      errors: {},
      name: '',
      isSpinner: false
    }
  },
  computed: {
    ...mapGetters(['getDesignationPaginate'])
  },
  methods: {
    ...mapActions(['fetchDesignationPaginate']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    createNew: async function () {
      this.isSpinner = true
      let formData = new FormData()
      formData.append('name', this.name)

      try {
        const response = await designationService.add(formData)

        this.fetchDesignationPaginate(this.getDesignationPaginate)
        this.hideModal()

        messageService.fnSweetAlertSuccessToast(
          'Designation - new',
          'Added successfully'
        )

        this.name = ''
        this.isSpinner = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Designation - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Designation - new',
              'Something wrong'
            )
            break
        }
        this.isSpinner = false
      }
    }
  }
}
</script>
